export const WidgetState = {
  START: 0,
  ACTIVE: 1,
};

export default {
  WidgetState,
};
